import { render } from "./ScrollSlider.vue?vue&type=template&id=52c9bd48&scoped=true"
import script from "./ScrollSlider.vue?vue&type=script&lang=js"
export * from "./ScrollSlider.vue?vue&type=script&lang=js"

import "./ScrollSlider.vue?vue&type=style&index=0&id=52c9bd48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c9bd48"]])

export default __exports__